// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeGifSelectBody = {
  providerGifId: string;
  requestId: string;
};

export type typeGifSelectOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { mediaId: string; previewUrl: string };
};

export type typeGifSelectOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeGifSelectOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeGifSelectOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaGifSelectBody = {
  type: "object",
  properties: {
    providerGifId: { type: "string", maxLength: 3000, minLength: 1 },
    requestId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["providerGifId", "requestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createGifSelect(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaGifSelectBody);
  }

  return async function postGifSelect(
    payload: typeGifSelectBody,
  ): Promise<typeGifSelectOutput200 | typeGifSelectOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postGifSelect" failed before calling the network. #257620def3e9`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#257620def3e9" },
        },
        data: null,
      } as typeGifSelectOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/gif/select`,
      httpMethod: "POST",
      options,
    })) as typeGifSelectOutput200 | typeGifSelectOutput400;
  };
}
